import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { apiKeysQueryOptions } from "@/app/api-keys/api/get-api-keys";
import { ApiKeysListSkeleton } from "@/app/api-keys/components/api-keys-list-skeleton";
import { ApiKeysList } from "@/app/api-keys/list";
import { PROJECT } from "@/app/capabilities/permissions";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/api-keys"
)({
  component: () => (
    <Suspense fallback={<ApiKeysListSkeleton />}>
      <ApiKeysList />
    </Suspense>
  ),
  beforeLoad: async (ctx) => {
    await requireProjectPermission(ctx, PROJECT.apiKeys.read);
    ctx.context.queryClient.prefetchQuery(
      apiKeysQueryOptions({
        organizationId: ctx.params.organizationId,
        projectId: ctx.params.projectId,
      })
    );
  },
  loader: () => ({
    crumb: "API Keys",
  }),
});
